import React from "react";

import { Tooltip } from "../../Tooltip";

type TitleLabelProps = {
	label: string;
	titleHref?: string;
	titleTooltip?: string;
	titleImage?: string;
};

/**
 * A label element that supports an optional link, tooltip, and integration image.
 * Pass this as the `label` ReactNode to the InputWrapper to render
 * titleHref/titleImage/titleTooltip features alongside the label text.
 */
export const TitleLabel = ({ label, titleHref, titleTooltip, titleImage }: TitleLabelProps) => (
	<span className="flex items-center gap-1">
		{titleHref && titleTooltip ? (
			<Tooltip content={titleTooltip} placement="top">
				<a href={titleHref} className="font-[inherit] text-inherit no-underline hover:underline">
					{label}
				</a>
			</Tooltip>
		) : titleHref ? (
			<a href={titleHref} className="font-[inherit] text-inherit no-underline hover:underline">
				{label}
			</a>
		) : (
			label
		)}
		{titleImage ? <img src={titleImage} alt="" className="h-3.5 w-auto" /> : null}
	</span>
);
